
















































































































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import SensorDetailComponent from "@/components/common/parts/SensorDetailComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import isOverThreshold from "@/typescript/lib/common/is_over_threshold";
import { MAX_SETTING_TEMP, MIN_SETTING_TEMP } from "@/config/thresholds";
import { Sensor } from "@/typescript/models/sensor/types";
import { NotThresholdRange } from "@/typescript/pages/temp_managements/index";
import { GetStoreSensorsResponse } from "../../typescript/api_client/emesh_api/stores/types";
import { getRoutePath } from "@/router/routes";
import { getAlertData } from "@/typescript/lib/common/get_alert_data";
import { getEquipmentIcon } from "@/typescript/lib/common/get_equipment_icon";
import { getStoreSensorsApi } from "../../typescript/api_client/emesh_api/stores/store_sensors_api";
import { getEquipmentsMeasurementApi } from "../../typescript/api_client/emesh_api/equipments/equipments_measurement_api";
import { convertNullObject } from "@/typescript/lib/common/convert_null_object";
import { getEquipmentsApi } from "@/typescript/api_client/emesh_api/equipments/equipments_api";
import { getWarningImage } from "@/typescript/lib/common/get_warning_image";
import { TempManagementsInfo } from "../../typescript/pages/temp_managements/types";
import { fillZero } from "@/typescript/lib/common/fill_zero";
import { AlertData } from "../../typescript/lib/common/types";
export {
  NotThresholdRange,
  Sensor,
  GetStoreSensorsResponse,
  AlertData,
  TempManagementsInfo
};

// 最新値に表示を更新する間隔(秒)
const DISPLAY_UPDATE_INTERVAL: number = 60 * 1000;

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    SensorDetailComponent,
    EllipsisComponent,
    FooterComponent
  }
})
export default class TempManagementsListPage extends Vue {
  $refs!: {
    content_component: Vue;
  };

  sortIconStatus: "asc" | "desc" = "asc";
  sortSensorNameStatus: "asc" | "desc" = "asc";
  sortWarnStatus: "asc" | "desc" = "asc";

  tempManagementsListInfos: TempManagementsInfo[] = [];

  currentDetailSensor: TempManagementsInfo | {} = {};
  storeName: string = "";
  detailPosition: string = "left-detail";

  // 最新値に表示を更新するタイマーID
  displayUpdateTimerId: number = 0;

  get isPopupOpend() {
    return Object.keys(this.currentDetailSensor).length > 0;
  }

  created() {
    this.setTempManagementInfos();
    this.displayUpdateTimerId = setInterval(() => {
      this.setTempManagementInfos();
    }, DISPLAY_UPDATE_INTERVAL);
  }

  destroyed() {
    if (this.displayUpdateTimerId) {
      clearInterval(this.displayUpdateTimerId);
    }
  }

  async getSensorData(
    equipmentId: string
  ): Promise<{
    temperature: string;
    alertStatus: number;
    alerts: AlertData[];
    battery: number | null;
    receiveBLESensitivity: number | null;
  }> {
    return await getEquipmentsMeasurementApi({
      equipment_id: equipmentId
    }).then(resp => {
      const temperature = resp.measurement_data[0]
        ? resp.measurement_data[0].temperature
        : "--";
      const battery = resp.measurement_data[0]
        ? resp.measurement_data[0].battery
        : null;
      const recieveSensitivity = resp.measurement_data[0]
        ? resp.measurement_data[0].receive_sensitivity
        : null;
      return {
        temperature: temperature,
        alerts: resp.alerts.map(a =>
          getAlertData(a.alert_id, resp.status as 0 | 1 | 2)
        ),
        alertStatus: resp.status,
        battery: battery,
        // null の場合はアイコンを without にしたいため、 -100 を代入する
        receiveBLESensitivity:
          recieveSensitivity === null
            ? -100
            : resp.measurement_data[0].receive_sensitivity
      };
    });
  }

  async getEquipment(
    equipmentId: string
  ): Promise<{
    iconKind: number;
    guardTime: number;
    serialNo: string;
    snoozingTime: number;
    locationNo: string;
  }> {
    return await getEquipmentsApi(equipmentId).then(resp => {
      return {
        iconKind: resp.icon_kind,
        guardTime: resp.guard_time,
        serialNo: resp.serial_no,
        snoozingTime: resp.snoozing_time,
        locationNo:
          resp.location_no === null ? "00" : fillZero(resp.location_no, 2)
      };
    });
  }

  async makeTempManagementInfos() {
    const storeSensors = await getStoreSensorsApi(
      this.$route.params.store_id
    ).then((resp: GetStoreSensorsResponse) => {
      return resp;
    });

    this.storeName = storeSensors.store_name;

    return Promise.all(
      storeSensors.sensors.map(async sensor => {
        const sensorData = await this.getSensorData(sensor.equipment_id);
        const equipment = await this.getEquipment(sensor.equipment_id);
        const res = {
          alertStatus: sensorData.alertStatus,
          alerts: sensorData.alerts,
          battery: sensorData.battery,
          equipmentId: sensor.equipment_id,
          equipmentName: sensor.equipment_name,
          guardTime: equipment.guardTime,
          iconKind: equipment.iconKind,
          lowerLimit: sensor.lower_limit,
          receiveBLESensitivity: sensorData.receiveBLESensitivity,
          serialNo: equipment.serialNo,
          snoozingTime: equipment.snoozingTime,
          temperature: sensorData.temperature,
          upperLimit: sensor.upper_limit,
          locationNo: equipment.locationNo
        };
        return convertNullObject(res, "--", [
          "equipmentName",
          "guardTime",
          "lowerLimit",
          "serialNo",
          "upperLimit"
        ]);
      })
    );
  }

  close() {
    this.currentDetailSensor = {};
  }

  setTempManagementInfos() {
    this.makeTempManagementInfos().then(resp => {
      this.tempManagementsListInfos = resp.sort(
        (a, b) => a.lowerLimit - b.lowerLimit
      ) as TempManagementsInfo[];
    });
  }

  // `ctTemp` から閾値に対応した目盛り数(%)を返却する
  getGaugeBarPercent(
    ctTemp: number,
    low: number = MIN_SETTING_TEMP,
    high: number = MAX_SETTING_TEMP
  ): number {
    // (100 / (high - low)) は 1 目盛り分の % を求める
    // (ctTemp - low) は 0 % を low に合わせるための計算式
    return (100 / (high - low)) * (ctTemp - low);
  }

  // 閾値以外の埋めなければならない左右の幅を返却する
  getNotThresholdRange(low: number, high: number): NotThresholdRange {
    // (100 / (`MAX_SETTING_TEMP` - `MIN_SETTING_TEMP`) にて 1 目盛り辺りの % を求める
    // Math.floor() にて少数第一位に切り捨て
    const scale =
      Math.floor((100 / (MAX_SETTING_TEMP - MIN_SETTING_TEMP)) * 10) / 10;
    // 100 - (`high` - `low`) にて閾値以外の面積を求め、目盛り数をかける
    const notThresholdRange = 100 - (high - low) * scale;
    // `MAX_SETTING_TEMP` - `high` にて右側の埋める表示幅を求め、目盛り数をかける
    const right = (MAX_SETTING_TEMP - high) * scale;

    return {
      right: right,
      left: notThresholdRange - right
    };
  }

  isOverThreshold(ctTemp: number, thLow: number, thHigh: number): boolean {
    return isOverThreshold(ctTemp, thLow, thHigh);
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  getSettingTemp(): { max: number; min: number } {
    return {
      max: MAX_SETTING_TEMP,
      min: MIN_SETTING_TEMP
    };
  }

  showDetail(sensor: Sensor) {
    this.currentDetailSensor = sensor;
  }

  getCategoryImage(iconNum: number, status: "on" | "off"): string {
    return getEquipmentIcon(iconNum, status);
  }

  getError(temp: string) {
    return temp === "ERROR" ? "error" : "";
  }

  getWarningImage(status: 0 | 1 | 2): string {
    return getWarningImage(status);
  }

  sort(arr: any[], sortKey: string, sortStatus: "asc" | "desc") {
    return arr.sort((a, b) => {
      // 2023/05/31 センサ名のソートはロケーションNo + センサ名でソート
      if (sortKey == "equipmentName") {
        const aTxt = a["locationNo"] + " " + a["equipmentName"];
        const bTxt = b["locationNo"] + " " + b["equipmentName"];
        if (aTxt > bTxt) {
          return sortStatus === "desc" ? -1 : 1;
        }
        if (aTxt < bTxt) {
          return sortStatus === "desc" ? 1 : -1;
        }
        return 0;
      } else {
        if (a[sortKey] > b[sortKey]) {
          return sortStatus === "desc" ? -1 : 1;
        }
        if (a[sortKey] < b[sortKey]) {
          return sortStatus === "desc" ? 1 : -1;
        }
        return 0;
      }
    });
  }

  sortIcon() {
    this.sortIconStatus = this.sortIconStatus === "desc" ? "asc" : "desc";
    this.sort(this.tempManagementsListInfos, "iconKind", this.sortIconStatus);
  }

  sortSensorName() {
    this.sortSensorNameStatus =
      this.sortSensorNameStatus === "desc" ? "asc" : "desc";
    this.sort(
      this.tempManagementsListInfos,
      "equipmentName",
      this.sortSensorNameStatus
    );
  }

  sortWarnMsg() {
    this.sortWarnStatus = this.sortWarnStatus === "desc" ? "asc" : "desc";
    this.sort(this.tempManagementsListInfos, "alerts", this.sortWarnStatus);
  }

  isError(temp: string | "ERROR") {
    return temp === "ERROR";
  }

  isDef(temp: string | "DEF") {
    return temp === "DEF";
  }
}
